import React from "react";
var __jsx = React.createElement;
import { EncounterFieldInput } from "./encounter-field-input";
import { FileUploadField } from "./file-upload-field";
import { CombinedFileField } from "./combined-file-field";
import { MessageSelectorField } from "./message-selector-field";
/** Renders the right control for a document field (file, letter, note, or basic input). */
export function DocFieldControl(_ref) {
  var field = _ref.field,
    fieldKey = _ref.fieldKey,
    value = _ref.value,
    valueName = _ref.valueName,
    dropdowns = _ref.dropdowns,
    setField = _ref.setField,
    workspaceId = _ref.workspaceId,
    patientId = _ref.patientId;
  if (field.type === "file_upload" && field.source_api === "letters") {
    return /*#__PURE__*/React.createElement(CombinedFileField, {
      field: field,
      fieldKey: fieldKey,
      value: value,
      valueName: valueName,
      setField: setField,
      workspaceId: workspaceId,
      patientId: patientId
    });
  }
  if (field.type === "file_upload") {
    return /*#__PURE__*/React.createElement(FileUploadField, {
      field: field,
      fieldKey: fieldKey,
      value: value,
      valueName: valueName,
      setField: setField,
      workspaceId: workspaceId,
      patientId: patientId
    });
  }
  if (field.type === "textarea" && field.source_api === "messages") {
    return /*#__PURE__*/React.createElement(MessageSelectorField, {
      field: field,
      fieldKey: fieldKey,
      value: value,
      setField: setField,
      patientId: patientId
    });
  }
  return /*#__PURE__*/React.createElement(EncounterFieldInput, {
    field: field,
    dropdowns: dropdowns,
    value: value,
    onChange: function onChange(next) {
      return setField(fieldKey, next);
    }
  });
}